import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorParserService {
  getServiceFromError(errorDetail: string | null | undefined): string | null {
    if (!errorDetail) {
      return null;
    }

    try {
      let dataArray;

      // Try to parse if it's a JSON string
      if (typeof errorDetail === 'string') {
        const jsonString = errorDetail.replace(/^\d+\s*-\s*/, '').trim();
        dataArray = JSON.parse(jsonString);
      } else {
        dataArray = errorDetail;
      }

      // If it's already an array, use it directly
      if (Array.isArray(dataArray)) {
        const failedOp = dataArray.find((op: any) =>
          op.state === 'CAPTURE_FAILED' || op.response?.code >= 400
        );

        if (failedOp?.service) {
          return failedOp.service;
        }
      }

      return null;
    } catch (e) {
      return null;
    }
  }
}
